/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from "react-router-dom";
import RemunerationMenu from "./RemunerationMenu";
import { SideBarDropDownItems } from "./dropDrownItems";

const InsideChildrenMenu = ({
  submenuOpen,
  setSubmenuOpen,
  insideChildren,
}) => (
  <li className="submenu">
    <a
      className="text-white"
      onClick={() =>
        setSubmenuOpen((prev) => ({
          ...prev,
          [insideChildren?.submenuName]:
            !submenuOpen[insideChildren?.submenuName],
        }))
      }
    >
      <span className="ml-2">{insideChildren?.name}</span>
      <span className="menu-arrow"></span>
    </a>
    <ul
      style={{
        display: submenuOpen[insideChildren?.submenuName] ? "block" : "none",
      }}
    >
      {insideChildren?.children.map((insideChild, index) => (
        <li key={index}>
          <Link to={insideChild?.link}>{insideChild.name}</Link>
        </li>
      ))}
    </ul>
  </li>
);

const ChildItem = ({
  child,
  props,
  branch_id,
  submenuOpen,
  setSubmenuOpen,
  staticDeduction,
  excludedDeductionNames,
}) => {
  if (child.name === "RemunerationMenu") {
    return child.details.map((remuneration, index) => (
      <RemunerationMenu
        key={index}
        mainSettings={props[remuneration.mainSettingsName]}
        branch_id={branch_id}
        submenuOpen={submenuOpen}
        setSubmenuOpen={setSubmenuOpen}
        staticDropDown={remuneration.showStatic ? staticDeduction : null}
        excludedNames={remuneration.showStatic ? excludedDeductionNames : null}
        name={remuneration.name}
        smallState={remuneration.smallState}
        mainIndex={remuneration.mainIndex}
        settingLevelOne={remuneration.settingLevelOne}
        linkName={remuneration.linkName}
      />
    ));
  }

  if (child?.insideChildren) {
    return (
      <InsideChildrenMenu
        submenuOpen={submenuOpen}
        setSubmenuOpen={setSubmenuOpen}
        insideChildren={child.insideChildren}
      />
    );
  }

  return (
    <li>
      <Link to={child.link}>{child.name}</Link>
    </li>
  );
};

const TopDropDown = ({ item, submenuOpen, setSubmenuOpen }) => {
  if (item?.link || item?.url) {
    const Tag = item.link ? Link : "a";
    const props = item.link
      ? { to: item.link }
      : { href: item.url, target: "_blank", rel: "noopener noreferrer" };
    return (
      <Tag className="side-anchor" {...props}>
        <span className="icon">{item?.icon}</span>
        <span>{item?.name}</span>
      </Tag>
    );
  }

  return (
    <a
      onClick={(e) => {
        e.preventDefault();
        setSubmenuOpen((prev) => ({
          ...prev,
          [item.submenuName]: !submenuOpen[item.submenuName],
        }));
      }}
      className="side-anchor text-white"
    >
      <span className="icon">{item?.icon}</span>
      <span>{item?.name}</span>
      <span className="menu-arrow"></span>
    </a>
  );
};

export const DropDownComponent = ({
  activeTab,
  setActiveTab,
  submenuOpen,
  setSubmenuOpen,
  props,
  branch_id,
  staticDeduction,
  excludedDeductionNames,
}) => (
  <>
    {SideBarDropDownItems()?.map((item, index) => (
      <li
        key={index}
        className={`submenu ${activeTab === item?.name ? "side-active" : ""}`}
        onClick={() => setActiveTab(item?.name)}
      >
        <TopDropDown
          item={item}
          submenuOpen={submenuOpen}
          setSubmenuOpen={setSubmenuOpen}
        />

        {item?.children?.length ? (
          <ul
            style={
              submenuOpen[item.submenuName]
                ? { display: "block" }
                : { display: "none" }
            }
          >
            {item.children.map((child, i) => (
              <ChildItem
                key={i}
                child={child}
                props={props}
                branch_id={branch_id}
                submenuOpen={submenuOpen}
                setSubmenuOpen={setSubmenuOpen}
                staticDeduction={staticDeduction}
                excludedDeductionNames={excludedDeductionNames}
              />
            ))}
          </ul>
        ) : null}
      </li>
    ))}
  </>
);
